
export const FIELD_REQUIRED = 'This field is required';
export const FIELD_INVALID_EMAIL = 'Please provide a valid email address';

export const LOGIN_ACCOUNT_DISABLED = 'Please verify your email address! Please do the <a href="#/forgot_password">forgot password</a> procedure.';